import { Tabs } from 'bold-ui'
import useSession from 'components/auth/useSession'
import { PageContainer } from 'components/layout/PageContainer'
import { PageContent } from 'components/layout/PageContent'
import { PecSwitch, PrivateRoute, TabLink } from 'components/route'
import React from 'react'
import { Redirect, useLocation } from 'react-router'
import { useRouteMatch } from 'react-router-dom'
import Permissions from 'types/Permissions'

import { CidadaoTabSectionModel } from '../types/CidadaoTabSectionModel'
import { CidadaoInformacoesView } from './CidadaoInformacoesView'
import { CidadaoUnificacoesView } from './CidadaoUnificacoesView'

export interface CidadaoTabSectionProps {
  cidadao: CidadaoTabSectionModel
}

export const CidadaoTabSection = (props: CidadaoTabSectionProps) => {
  const { cidadao } = props
  const match = useRouteMatch()
  const location = useLocation()
  const { hasAuthorization } = useSession()

  const renderInformacoes = () => <CidadaoInformacoesView cidadao={cidadao} mostrarProntuario={true} />

  const renderUnificacoes = () => <CidadaoUnificacoesView idCidadao={cidadao.id} temUnificacoes={cidadao.unificado} />

  return (
    <>
      <PageContainer>
        <Tabs style={{ borderBottom: '1px solid #d3d4dd', marginTop: '1rem' }}>
          <TabLink to={`${match.url}/informacoes${location.search}`}>Informações</TabLink>
          <TabLink to={`${match.url}/unificacoes${location.search}`}>Unificações</TabLink>
        </Tabs>
      </PageContainer>

      <PageContent type='transparent'>
        <PecSwitch>
          {hasAuthorization(Permissions.gestaoDeCadastrosDeCidadao.visualizarCidadao) && (
            <Redirect exact path={`${match.url}`} to={`${match.url}/informacoes${location.search}`} />
          )}
          <PrivateRoute
            exact
            path={`${match.url}/informacoes`}
            render={renderInformacoes}
            permission={Permissions.gestaoDeCadastrosDeCidadao.visualizarCidadao}
          />
          <PrivateRoute
            exact
            path={`${match.url}/unificacoes`}
            render={renderUnificacoes}
            permission={Permissions.gestaoDeCadastrosDeCidadao.visualizarCidadao}
          />
        </PecSwitch>
      </PageContent>
    </>
  )
}
